import { usePermissions } from '@topconagriculture/casbin-react';
import { Action, Resource } from '@topconagriculture/permissions';
export const useAppPermissions = () => {
    const { hasPermission: hasFieldsApp } = usePermissions({
        resource: Resource.FIELDS,
        action: Action.LAUNCH,
    });
    const { hasPermission: hasStorageApp } = usePermissions({
        resource: Resource.STORAGE,
        action: Action.LAUNCH,
    });
    const { hasPermission: hasFleetApp } = usePermissions({
        resource: Resource.FLEET,
        action: Action.LAUNCH,
    });
    const { hasPermission: hasSupportApp } = usePermissions({
        resource: Resource.SUPPORT_APP,
        action: Action.LAUNCH,
    });
    const { hasPermission: hasMarketApp } = usePermissions({
        resource: Resource.MARKET,
        action: Action.LAUNCH,
    });
    const { hasPermission: hasInventoryWidgetPermission } = usePermissions({
        resource: Resource.FEED_WIDGET_INVENTORY,
        action: Action.USE,
    });
    const { hasPermission: hasLoadDeviationWidgetPermission } = usePermissions({
        resource: Resource.FEED_WIDGET_INGREDIENT_LOAD_DEVIATION,
        action: Action.USE,
    });
    const { hasPermission: hasDeliverDeviationWidgetPermission } = usePermissions({
        resource: Resource.FEED_WIDGET_PEN_DELIVER_DEVIATION,
        action: Action.USE,
    });
    return {
        [Resource.MARKET]: hasMarketApp,
        [Resource.SUPPORT_APP]: hasSupportApp,
        [Resource.FLEET]: hasFleetApp,
        [Resource.FIELDS]: hasFieldsApp,
        [Resource.STORAGE]: hasStorageApp,
        [Resource.FEED_WIDGET_INVENTORY]: hasInventoryWidgetPermission,
        [Resource.FEED_WIDGET_INGREDIENT_LOAD_DEVIATION]: hasLoadDeviationWidgetPermission,
        [Resource.FEED_WIDGET_PEN_DELIVER_DEVIATION]: hasDeliverDeviationWidgetPermission,
    };
};
//# sourceMappingURL=useAppPermissions.js.map